import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { selectLogo, translate } from 'core/utils';
import { BaasicInput } from 'core/components';

const PasswordChangeTemplate = ({ t, viewStore: { form, loading, isResetPassword } }) => {
	const logo_show = selectLogo();
	return (
		<main className="body--secondary">
			<section className="w--400--px align--h--center padd--top--med">
				<img className="w--200--px display--b align--h--center" src={logo_show} alt="Logo" />
				<form className="form card card--med spc--top--med" onSubmit={form.onSubmit}>
					<h3 className="spc--bottom--sml">{t(!isResetPassword ? 'PASSWORDCHANGETITLE' : 'PASSWORDRESETTITLE')}</h3>
					{!isResetPassword && <BaasicInput field={form.$('oldPassword')} className="fs-mask" showCheckmark={false} />}
					<BaasicInput
						field={form.$('newPassword')}
						className="fs-mask"
						showCheckmark={false}
					/>
					<BaasicInput
						field={form.$('newPasswordConfirm')}
						className="fs-mask"
						showCheckmark={false}
					/>
					{form.error && (
						<div>
							<p className="type--color--warning spc--bottom--sml">{translate(form.error)}</p>
						</div>
					)}
					<div className="group">
						<button className="btn btn--med btn--primary pull" type="submit" disabled={loading}>
							{loading ? (
								<div className="spinnercont spc--right--sml">
									<div className="spinner"></div>
								</div>
							) : null}
							{t('SAVE')}
						</button>
					</div>
				</form>
			</section>
		</main>
	);
};

export default defaultTemplate(PasswordChangeTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/membership/pages/PasswordChangeTemplate.jsx